import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import {
  AppBar,
  Toolbar,
  Typography
} from '@material-ui/core';

const styles = theme => ({
  root: {
    backgroundColor: 'rgba(0,0,0,0.8)',
  },
  name1: {
    color: '#FFFFFF',
  },
  name2: {
    marginLeft: '10px',
    color: '#FFFFFF',
  }
});

class Header extends Component {

  render() {
    const { classes } = this.props;
    return (
        <AppBar position="fixed" className={classes.root}>
          <Toolbar>
            <Typography variant="headline" className={classes.name1}>
              GRENARCH
            </Typography>
            <Typography variant="subheading" className={classes.name2}>
              Technologies
            </Typography>
          </Toolbar>
        </AppBar>
    );
  }
};

Header.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Header);



// WEBPACK FOOTER //
// ./src/components/common/Header.js